import { useFetchedPromptVariables } from '../../growegy-ai/variables/hooks/useFetchedPromptVariables';
import { VARIABLE_COMPANY, VARIABLE_METADATAS } from '../../growegy-ai/types';
import { getOrCreateVariableViewModel } from '../../growegy-ai/util';
import { VariableBox } from '../../growegy-ai/variables/components/VariableBox';
import { OnboardingToolbar } from './OnboardingToolbar';
import { nonBreakableSpace } from '../../util/utils';
import { useFetchedPrompts } from '../../growegy-ai/library/hooks/useFetchedPrompts';
import { useFetchedProgramTypes } from '../../program/hooks/useFetchedProgramTypes';
import { useOnboardingWizardStepAnalyticsPage } from '../hooks/useOnboardingWizardStepAnalyticsPage';
import { ONBOARDING_STEP_VARIABLES } from '../types';
import React from 'react';

export const VariablesStep = (props: {
  stepIndex: number;
  totalSteps: number;
  onNext: () => void;
  onSkip: () => void;
}) => {
  useOnboardingWizardStepAnalyticsPage(ONBOARDING_STEP_VARIABLES);
  const { stepIndex, totalSteps, onNext, onSkip } = props;
  const {
    query: { data: variables },
    queryStatusComponent,
  } = useFetchedPromptVariables();

  // Prefetch data for the next step.
  useFetchedPrompts();
  useFetchedProgramTypes();

  if (!variables)
    return <div className="growegy-spinner__wrapper--big"> {queryStatusComponent}</div>;
  return (
    <div className="onboarding-step__container">
      <div className="onboarding-step__goal-question">
        Provide a brief description of your company, your products, and the demographic of your
        ideal customer.
        <br />
        <br />
        You can later amend this in Growegy AI{nonBreakableSpace}→{nonBreakableSpace}
        Personalization.
      </div>
      <div className="onboarding-step__container overflow-auto">
        <div className="onboarding-step__container onboarding-step__extra-padding">
          {VARIABLE_METADATAS.filter((x) => x.includedInOnboarding).map((x, i) => {
            const variable = getOrCreateVariableViewModel(variables, x, i);
            return (
              <VariableBox
                key={variable.variableValue.name}
                item={variable}
                showName={!variable.hideName}
                hideNameValue={variable.variableValue.name === VARIABLE_COMPANY}
              />
            );
          })}
        </div>
      </div>
      <OnboardingToolbar
        stepIndex={stepIndex}
        totalSteps={totalSteps}
        onNext={onNext}
        onSkip={onSkip}
      />
    </div>
  );
};
